import { render, staticRenderFns } from "./ProfilePrivacy.vue?vue&type=template&id=f1b57170"
import script from "./ProfilePrivacy.vue?vue&type=script&lang=js"
export * from "./ProfilePrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports